export default __webpack_public_path__ + "static/media/xlsx.2d87381c.png";